module.exports = __webpack_public_path__ + "static/media/21_A.dffd996c.png";